import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClientService } from 'app/core/services/http-client.service';

import { Dealership, ResponseMetadata } from 'app/model';
import { EndpointsConstants } from 'app/shared/constants/endpoints.constants';

@Injectable()
export class ConcessionaireService {
  constructor(private httpService: HttpClientService) {
  }

  getAllDealerships(params?): Observable<{ dealerships: Dealership[], metadata: ResponseMetadata }> {
    return this.httpService
      .get<{ dealerships: Dealership[], metadata: ResponseMetadata }>(EndpointsConstants.dealerships.all, params)
      .pipe(map(response => {
        return {
          dealerships: response['data'].dealerships.map(dealership => new Dealership(dealership)),
          metadata: response['data'].metadata
        };
      }));
  }

  getDealership(id: string): Observable<Dealership> {
    const endpointUrl = EndpointsConstants.dealerships.single.replace('{id}', id);
    return this.httpService.get<Dealership>(endpointUrl).pipe(map(response => new Dealership(response['data'])));
  }

  saveDealership(dealership: Dealership): Observable<Dealership> {
    return this.httpService.post(EndpointsConstants.dealerships.all, dealership)
      .pipe(map(response => new Dealership(response['data'])));
  }

  updateDealerships(id: string, editedDealership: Dealership): Observable<Dealership> {
    const endpointUrl = EndpointsConstants.dealerships.single.replace('{id}', id);
    return this.httpService.put(endpointUrl, editedDealership).pipe(map(response => new Dealership(response['data'])));
  }

  deleteDealership(id: string): Observable<{ message: string }> {
    const endpointUrl = EndpointsConstants.dealerships.single.replace('{id}', id);
    return this.httpService.delete<{ message: string }>(endpointUrl);
  }
}
